import clsx from "clsx";
import "hiding-header/dist/style.css";
import Link from "next/link";
import type { FunctionComponent } from "react";
import type { LinkResult } from "../data/LinkFragment";
import { contemberLinkToHref } from "../utilities/contemberLinkToHref";
import { headerLinkToHrefTargetRel } from "../utilities/headerLinkToHref";
import styles from "./HeaderSubmenuProducts.module.sass";
import { Icon } from "./Icon";
import { ResponsiveImage } from "./ResponsiveImage";
import { useTranslate } from "./contexts/TranslationsContextProvider";

export type HeaderSubmenuProductsProps = {
  // biome-ignore lint/suspicious/noExplicitAny: dynamic data structure coming from website API
  items: any[];
  isFullProductsButton?: boolean;
  productsPageLink: LinkResult;
  isInHamburgerMenu?: boolean;
};

export const HeaderSubmenuProducts: FunctionComponent<
  HeaderSubmenuProductsProps
> = ({
  items,
  productsPageLink,
  isFullProductsButton = false,
  isInHamburgerMenu = false,
}) => {
  const translations = useTranslate();
  return (
    <div
      className={clsx(
        styles.wrapper,
        isInHamburgerMenu && styles.is_inHamburgerMenu
      )}
    >
      <div className={styles.in}>
        <div className={styles.box}>
          <ul className={styles.list}>
            {items.map((item) =>
              item?.localesByLocale?.link ? (
                <li key={item.id} className={styles.item}>
                  <Link
                    className={styles.itemLink}
                    {...headerLinkToHrefTargetRel(item.localesByLocale.link)}
                  >
                    <div
                      className={clsx(
                        styles.itemImage,
                        item.isLogoTransparent && styles.is_transparent
                      )}
                    >
                      {item.tileLogo && (
                        <ResponsiveImage
                          className={styles.itemImageIn}
                          alt={item.tileLogo.alt ?? ""}
                          src={item.tileLogo.url}
                          width={item.tileLogo.width}
                          height={item.tileLogo.height}
                          sizes="80px"
                          isBorderRadius
                        />
                      )}
                    </div>
                    <div className={styles.itemContent}>
                      <h6 className={styles.itemTitle}>
                        {item.localesByLocale.name}
                      </h6>
                      {item.localesByLocale.shortInfo && (
                        <p className={styles.itemShortInfo}>
                          {item.localesByLocale.shortInfo}
                        </p>
                      )}
                    </div>
                  </Link>
                </li>
              ) : null
            )}
            {isFullProductsButton &&
              productsPageLink &&
              contemberLinkToHref(productsPageLink) !== "" && (
                <li className={styles.item}>
                  <Link
                    className={styles.itemLink}
                    {...headerLinkToHrefTargetRel(productsPageLink)}
                  >
                    <div className={styles.itemImage}>
                      <div className={styles.itemArrowButton}>
                        <Icon name="arrowLink" />
                      </div>
                    </div>
                    <div className={styles.itemContent}>
                      <h6 className={styles.itemTitle}>
                        {translations(
                          "headerSubmenuProducts.listPageProducts.title"
                        )}
                      </h6>
                      <p className={styles.itemShortInfo}>
                        {translations(
                          "headerSubmenuProducts.listPageProducts.shortInfo"
                        )}
                      </p>
                    </div>
                  </Link>
                </li>
              )}
          </ul>
        </div>
      </div>
    </div>
  );
};
